module.exports = Object.freeze({
  API_URL: "https://api.umapps.in",
  ENV_TYPE: "PROD",
  MAP_KEY: "",
});
